<template>
    <div class="lockIndex">
        <topNav :title="title"></topNav>
       
        <commonInput @commitCarNum="searchLockStatus" :btntxt="'查询锁定状态'"></commonInput>
    </div>
</template>
<script>
import topNav from "@/components/topnav/topnav"
import {Toast,Dialog} from 'vant';
import {DETAIL as API} from "@/assets/api";
import commonInput from "@/components/common/commonInput"
export default {
    name: 'lockIndex',
    components:{
        topNav,
        commonInput
    },
    data() {
        return {
            title:"锁车",

        }
    },
    mounted(){
        // this.couponValue = sessionStorage.getItem("coupon_value");
        // this.couponValidhours = sessionStorage.getItem("coupon_validhours");
        // this.couponType = this.getCouponType(sessionStorage.getItem("coupon_type"));
    },
    methods:{
        searchLockStatus(carNum){//查询车辆锁定状态
            this.commonUtil.setCookie("carNum2",carNum,30)
            let originalId = sessionStorage.getItem("originalId");
            let req = {
                carNum,
                originalId,
            }
            this.$http({
                method: 'post',
                url: API.GET_LOCK_STATUS,
                data: this.qs.stringify(req),
                success: function(data){
                    if(data.code == 0){
                        data = data.data;
                        this.$router.push({
                            name:"lockCar",
                            params:{
                                status:data.lock,
                                id:data.commid
                            },
                            query:{
                                carNum,
                            }
                        });
                    }else{
                        this.$toast({
                            duration: 1200,
                            message: data.msg
                        });
                    }
                }.bind(this),
                error: function(error){
                    console.log(error)
                }
            })
        },
    },
    created(){
    },
    watch:{
    }


}
</script>
<style>
.lockIndex{
    background: #fff;
}
</style>




// WEBPACK FOOTER //
// src/components/lockCar/lockIndex.vue